module.exports = __webpack_public_path__ + "img/address.46d516e3.svg";